import requests from "../util";

const url = "/seller-gateway";

const SellerGatewayApi = {
    create: (data: any) =>
        requests.post(`${url}`, data),

    findSeller: (params: { idSeller?: string; document?: string }, gatewayId?: string) => {
        const query = new URLSearchParams();

        if (params.idSeller) query.append("idSeller", params.idSeller);
        if (params.document) query.append("document", params.document);
        if (gatewayId) query.append("gatewayId", gatewayId);

        return requests.get(`${url}/find-seller?${query.toString()}`);
    },

    updateBankAccount: (data: any, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.patch(`${url}/bank-account${query}`, data);
    },

    updateSellerRates: (data: any, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.patch(`${url}/rates${query}`, data);
    },

    findSellerRates: (sellerId: number, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.get(`${url}/${sellerId}/rates${query}`);
    },

    findAllSellersRate: (gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.get(`${url}/sellers-rates${query}`);
    },

    requestRedeem: (sellerId: string, data: any, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.post(`${url}/${sellerId}/redeems${query}`, data);
    },

    findTransferDetails: (sellerId: number, transferDate?: string, gatewayId?: string) => {
        const query = new URLSearchParams();
        if (transferDate) query.append("transferDate", transferDate);
        if (gatewayId) query.append("gatewayId", gatewayId);

        return requests.get(
            `${url}/${sellerId}/transfers/details?${query.toString()}`
        );
    },

    findBalance: (sellerId: number, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.get(`${url}/${sellerId}/balance${query}`);
    },

    findFutureReceivables: (
        idSeller: number,
        initialDate: string,
        finalDate: string,
        gatewayId?: string,
    ) => {
        const query = new URLSearchParams({
            idSeller: String(idSeller),
            initialDate: initialDate,
            finalDate: finalDate,
        });
        if (gatewayId) query.append("gatewayId", gatewayId);

        return requests.get(`${url}/reports/future-receivables?${query.toString()}`);
    },

    findReceivableDetails: (sellerId: number, date: string, gatewayId?: string) => {
        const query = new URLSearchParams({ date });
        if (gatewayId) query.append("gatewayId", gatewayId);
        return requests.get(
            `${url}/${sellerId}/receivables/details?${query.toString()}`
        );
    },

    findByStoreId: (storeId: string) =>
        requests.get(`${url}/store/${storeId}`),

    deleteByStoreId: (storeId: string) =>
        requests.delete(`${url}/store/${storeId}`),

    findSellerTransactions: (
        sellerId: string,
        params: {
            startDate?: string;
            endDate?: string;
            page?: number;
            size?: number;
        },
        gatewayId?: string,
    ) => {
        const query = new URLSearchParams();
        if (params.startDate) query.append("startDate", params.startDate);
        if (params.endDate) query.append("endDate", params.endDate);
        if (params.page != null) query.append("page", String(params.page));
        if (params.size != null) query.append("size", String(params.size));
        if (gatewayId) query.append("gatewayId", gatewayId);
        return requests.get(`${url}/${sellerId}/transactions?${query.toString()}`);
    },

    findStatement: (data: {
        idSeller?: string;
        cnpj?: string;
        executionDateInitial?: string;
        executionDateFinal?: string;
        uuid_order?: string;
        uuid_charge?: string;
    }, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.post(`${url}/reports/statement${query}`, data);
    },

    refundCharge: (uuid: string, data: { asFraud?: boolean }, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.patch(`${url}/${uuid}/refund${query}`, data);
    },

    partialRefundCharge: (uuid: string, data: { value: number }, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.patch(`${url}/${uuid}/partial-refund${query}`, data);
    },

    findPartialRefund: (uuid: string, gatewayId?: string) => {
        const query = gatewayId ? `?gatewayId=${encodeURIComponent(gatewayId)}` : "";
        return requests.get(`${url}/${uuid}/partial-refund${query}`);
    },
};



export default SellerGatewayApi;